import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import withAuthentication from 'apex-web/lib/hocs/withAuthentication';
import WalletCardGridContainer from '../components/WalletCards/WalletCardGridContainer';
// TODO: this file has to be imported from apex-web
import WalletRowListContainer from '../components/WalletRows/WalletRowListContainer';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import NomixInfoIcon from '../images/icons/icon-nomix-info.svg';
import { kycVerificationLevelsSelector } from 'apex-web/lib/redux/selectors/kycLevelsSelectors';
import './WalletsPage.css';
import { formatNumberToLocale } from '../helpers/numberFormatter';
import BigNumber from 'bignumber.js';
import { fundedPositionsSelector } from '../redux/selectors/balancesWithPrices';
import { isSelectedAccountRetirementSelector } from '../redux/selectors/accountSelectors';

const layoutClasses = getBEMClasses('wallets-page');

const detailsLink = '/wallets/product-details';

const WalletsPage = (props, context) => {
  const totalBalance = useMemo(
    () =>
      props.products.reduce((acc, item) => {
        const formattedNotionalValue = item.NotionalValue;
        return acc.plus(formattedNotionalValue);
      }, new BigNumber(0)),
    [props.products]
  );
  return (
    <div className={layoutClasses()}>
      <div className={layoutClasses('accent-bar')} />
      <div className={layoutClasses('container')}>
        {props.isShowFundsLink && (
          <div className={layoutClasses('banner')}>
            <div className={layoutClasses('banner-title-wrapper')}>
              <img src={NomixInfoIcon} alt="Nomix Info" />
              <div className={layoutClasses('banner-title')}>
                <span className={layoutClasses('banner-title-desktop')}>
                  {context.t('Click the button to fund your account with fiat.')}
                </span>
                <span className={layoutClasses('banner-title-mobile')}>
                  {context.t('Fund your account with fiat.')}
                </span>
              </div>
            </div>
            <div
              className={layoutClasses('banner-btn')}
              onClick={() => {
                const jwtToken = localStorage.getItem('JWTToken');
                window.open(
                  `${
                    process.env.REACT_APP_NOMIX_TRANFER_FUNDS_URL
                  }?token=${jwtToken}`,
                  '_blank'
                );
              }}>
              {context.t('Fund with fiat')}
            </div>
          </div>
        )}

        <header className={layoutClasses('hero')}>
          <h1 className={layoutClasses('title')}>{context.t('Wallets')}</h1>
          <p className={layoutClasses('lede')}>
            {context.t(
              'Funded balances, notional value in USD, and open each asset. Unfunded accounts appear below.'
            )}
          </p>
        </header>

        <div className={layoutClasses('funded')}>
          <div
            className={layoutClasses(
              'wallet-list-container-header',
              'with-total'
            )}>
            <div className={layoutClasses('section-head')}>
              <span className={layoutClasses('section-eyebrow')}>
                {context.t('Funded')}
              </span>
              <h2 className={layoutClasses('section-heading')}>
                {context.t('Funded Accounts')}
              </h2>
            </div>
            <div className={layoutClasses('total-balance')}>
              <span className={layoutClasses('total-balance-title')}>
                {context.t('Current Balance')}
              </span>
              <span className={layoutClasses('total-balance-amount')}>
                {formatNumberToLocale(totalBalance, 2)} USD
              </span>
            </div>
          </div>
          <div className={layoutClasses('wallet-card-container')}>
            <WalletCardGridContainer detailsLink={detailsLink} />
          </div>
        </div>

        <div className={layoutClasses('unfunded')}>
          <div className={layoutClasses('wallet-list-container-header')}>
            <div className={layoutClasses('section-head')}>
              <span className={layoutClasses('section-eyebrow')}>
                {context.t('Unfunded')}
              </span>
              <h2 className={layoutClasses('section-heading')}>
                {context.t('Unfunded Accounts')}
              </h2>
            </div>
          </div>
          <div className={layoutClasses('wallet-list-container')}>
            <WalletRowListContainer detailsLink={detailsLink} />
          </div>
        </div>
      </div>
      <div className={layoutClasses('footer')}>
        <PageFooterLayout />
      </div>
    </div>
  );
};

WalletsPage.contextTypes = {
  t: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { verificationLevel } = kycVerificationLevelsSelector(state);
  const isSelectedAccountRetirement = isSelectedAccountRetirementSelector(
    state
  );

  return {
    products: fundedPositionsSelector(state),
    isShowFundsLink:
      Number(verificationLevel) > 0 && !isSelectedAccountRetirement
  };
};

export default connect(mapStateToProps)(withAuthentication(WalletsPage));
